import { apiFetch, buildApiError } from './httpClient';

async function http(path, options = {}) {
  const resp = await apiFetch(path, options);
  if (!resp.ok) {
    throw await buildApiError(resp, 'Unable to send feedback');
  }
  return resp.json();
}

export const feedbackService = {
  createFeedback(data) {
    return http('/api/feedback', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },
};
